import Vue from 'vue';
import { API_HOST } from '../../constants';

export default {
  create(params) {
    return Vue.axios.post(`${API_HOST}/paypal/create-payment`, params);
  },
  execute(params) {
    return Vue.axios.post(`${API_HOST}/paypal/execute-payment`, params);
  },
  cancel(params) {
    return Vue.axios.post(`${API_HOST}/paypal/cancel-payment`, params);
  },
  check(params) {
    return Vue.axios.post(`${API_HOST}/paypal/check-payment`, params);
  },

};



// WEBPACK FOOTER //
// ./src/api/payment/paypal.js